/** InsCoder WANG.J 2026-08-04 B + Journal listing interactions **/
(function () {
  'use strict';

  var STORAGE_KEY = 'kavalriRecentlyReadArticlesV1';

  function readHistory() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function isSafeArticleUrl(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      return parsed.origin === window.location.origin && parsed.pathname.indexOf('/blogs/') === 0;
    } catch (error) {
      return false;
    }
  }

  function recordArticle(card) {
    var url = card.dataset.articleUrl;
    if (!isSafeArticleUrl(url)) return;

    var entry = {
      url: new URL(url, window.location.origin).pathname,
      title: card.dataset.articleTitle || '',
      date: card.dataset.articleDate || '',
      blogHandle: card.dataset.blogHandle || ''
    };
    if (!entry.title) return;

    var history = readHistory().filter(function (item) {
      return item && item.url !== entry.url;
    });
    history.unshift(entry);

    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(history.slice(0, 24)));
    } catch (error) {
      return;
    }
  }

  function renderRecent(root) {
    if (root.dataset.recentEnabled !== 'true') return;

    var aside = root.querySelector('[data-journal-recent]');
    var list = root.querySelector('[data-journal-recent-list]');
    var emptyMessage = root.querySelector('[data-journal-recent-empty]');
    if (!aside || !list) return;

    var limit = parseInt(root.dataset.recentLimit, 10) || 4;
    var blogHandle = root.dataset.blogHandle;
    var entries = readHistory().filter(function (entry) {
      return entry && entry.title && isSafeArticleUrl(entry.url) && (!entry.blogHandle || entry.blogHandle === blogHandle);
    }).slice(0, limit);

    list.replaceChildren();
    if (!entries.length) {
      aside.hidden = false;
      if (emptyMessage) emptyMessage.hidden = false;
      return;
    }

    entries.forEach(function (entry) {
      var item = document.createElement('div');
      var link = document.createElement('a');
      var date = document.createElement('span');

      item.className = 'cust-journal-listing__recent-item';
      link.className = 'cust-journal-listing__recent-link';
      link.href = new URL(entry.url, window.location.origin).pathname;
      link.textContent = entry.title;
      date.className = 'cust-journal-listing__recent-date';
      date.textContent = entry.date;

      item.appendChild(link);
      if (entry.date) item.appendChild(date);
      list.appendChild(item);
    });

    aside.hidden = false;
    if (emptyMessage) emptyMessage.hidden = true;
  }

  function bindLoadMore(root) {
    var button = root.querySelector('[data-journal-load-more]');
    if (!button) return;

    button.addEventListener('click', function () {
      var nextUrl = button.dataset.nextUrl;
      if (!nextUrl || button.classList.contains('is-loading')) return;

      button.classList.add('is-loading');
      button.disabled = true;

      fetch(nextUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to load articles');
          return response.text();
        })
        .then(function (html) {
          var page = new DOMParser().parseFromString(html, 'text/html');
          var incomingList = page.querySelector('[data-journal-article-list]');
          var currentList = root.querySelector('[data-journal-article-list]');
          if (!incomingList || !currentList) throw new Error('Article list missing');

          Array.from(incomingList.children).forEach(function (article) {
            currentList.appendChild(article);
          });

          var incomingButton = page.querySelector('[data-journal-load-more]');
          if (incomingButton && incomingButton.dataset.nextUrl) {
            button.dataset.nextUrl = incomingButton.dataset.nextUrl;
          } else {
            button.hidden = true;
          }
        })
        .catch(function () {
          button.removeAttribute('hidden');
        })
        .finally(function () {
          button.classList.remove('is-loading');
          button.disabled = false;
        });
    });
  }

  function init(root) {
    if (!root || root.dataset.journalBound === 'true') return;
    root.dataset.journalBound = 'true';

    root.addEventListener('click', function (event) {
      var link = event.target.closest('[data-journal-article-link]');
      if (!link) return;
      var card = link.closest('[data-journal-article]');
      if (card) recordArticle(card);
    });

    bindLoadMore(root);
    renderRecent(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-cust-journal-listing]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
/** InsCoder WANG.J 2026-08-04 E + Journal listing interactions **/
